export const BROKERAGE = {
    value: "BROKERAGE",
    key: "clientTypes.brokerage",
};

export const TPA = {
    value: "TPA",
    key: "clientTypes.tpa",
};

export const TPP = {
    value: "TPP",
    key: "clientTypes.tpp",
};

export const ASO = {
    value: "ASO",
    key: "clientTypes.aso",
};

export default [BROKERAGE, TPA, TPP, ASO];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/clientTypes.js